import { useRef } from "react";
import { motion, useInView } from "framer-motion";

// Encabezado numerado de capítulo (01 / CATÁLOGO, etc.)
export default function Chapter({ num, eyebrow, title }) {
    const ref = useRef(null);
    const show = useInView(ref, { once: true, margin: "-60px" });

    return (
        <div ref={ref} className="mb-14 sm:mb-20">
            <motion.p
                animate={show ? { opacity: 1, y: 0 } : { opacity: 0, y: 16 }}
                transition={{ duration: 0.6 }}
                className="font-mono-jf text-xs uppercase tracking-[0.25em] text-[#6B1D2F]"
                data-testid={`chapter-${num}-eyebrow`}
            >
                {num} / {eyebrow}
            </motion.p>
            <div className="mt-4 overflow-hidden">
                <motion.h2
                    animate={show ? { y: "0%" } : { y: "110%" }}
                    transition={{ duration: 0.8, ease: [0.22, 1, 0.36, 1] }}
                    className="font-display text-3xl sm:text-4xl lg:text-5xl tracking-tight leading-tight text-[#141312]"
                    data-testid={`chapter-${num}-title`}
                >
                    {title}
                </motion.h2>
            </div>
            <motion.div
                animate={show ? { scaleX: 1 } : { scaleX: 0 }}
                transition={{ duration: 0.9, ease: [0.22, 1, 0.36, 1], delay: 0.15 }}
                className="mt-6 h-px w-full origin-left bg-[#E5E0D5]"
            />
        </div>
    );
}
